/**
 * OnboardingEditorPageV2
 *
 * Page for editing an onboarding using the V2 schema (screensV2 subcollection).
 * Uses OnboardingEditorModalV2 in route mode for full-screen display.
 *
 * Route: /project/:projectId/onboarding-v2/:onboardingId
 *
 * Sprint: Schema V2 Migration - Sprint 1
 */

import React from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Alert, Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { OnboardingEditorModalV2 } from '../components/OnboardingEditorModalV2';

export function OnboardingEditorPageV2() {
  const { projectId, onboardingId } = useParams<{ projectId: string; onboardingId: string }>();
  const navigate = useNavigate();
  // I4 (analytics-versions-and-publish-flow): Reports deep links carry the
  // trafficked version (`?version=<id>`) so the canvas opens the version that
  // actually served the traffic instead of the working head. Read once per
  // mount — switching inside the editor stays editor state.
  const [searchParams] = useSearchParams();
  const [versionParam] = React.useState(() => searchParams.get('version') || undefined);

  if (!projectId || !onboardingId) {
    return (
      <Box sx={{ p: 3 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{ mb: 2 }}
        >
          Back
        </Button>
        <Alert severity="error">Missing project or onboarding ID</Alert>
      </Box>
    );
  }

  return (
    <OnboardingEditorModalV2
      projectId={projectId}
      onboardingId={onboardingId}
      versionId={versionParam}
    />
  );
}

export default OnboardingEditorPageV2;
